<div> 
  <div class="card-grid-2">
      <a>
          <div class="card-grid-2-image-left">
              <div class="jobsdiv">
                  <div class="image-box"> 
                    <img [src]="job?._source?.companyPic != '' ? recruiterImagePath + job?._source?.companyPic :  '../../../../../../assets/images/brands/ziptech.png'" alt="jobBox">
                
                </div>
                  <div class="right-info"> 
                      <a class="name-job">{{job?._source?.companyName}}</a>
                      <span class="location-small" *ngIf="job?._source?.workPlace != 'Remote'">{{job?._source?.location || "NA"}}</span>
                      <span class="location-small" *ngIf="job?._source?.workPlace == 'Remote'">Remote</span>
                  </div>
              </div>
              <div class="mt-3 timeZone">
                  <span class="card-time">{{dateInMilisecond(job?._source?.createdAt) | dateAgoConvertor}}</span> |
                  <span class="card-applicants">{{job?.applicantsCount}} Applicants</span> |
                  <span class="card-briefcase">{{job?._source?.employmentType || "NA"}}</span>
              </div>
          </div>
          <div class="card-block-info">
              <div class="card-block-inner">
                  <h6>{{job?._source?.jobTitle}}
                      <span *ngIf="job?._source?.isApplied == 1"><img src="assets/images/applied.svg" class="wt"></span>
                  </h6>
                  <p class="salary">{{jobSalaryFilter(job)}}</p>
              </div>
              <div class="apply">
                  <!-- <img src="{{job?._source?.saveStatus == 0 ?  'assets/images/ic_unsave.svg':'assets/images/saved_job.svg'}}"
                      alt="unsave" (click)="saveUnsaveJob(job);$event.stopPropagation()">  -->
                    <a *ngIf="!showSaved" tooltip="Unsave" title="Unsave" placement="left">
                        <img src="assets/images/ic_unsave.svg"
                        alt="unsave" (click)="saveUnsaveJob(job);$event.stopPropagation()">  
                    </a> 
                    <a *ngIf="showSaved" tooltip="Saved" title="Saved" placement="left">
                        <img src="assets/images/saved_job.svg"
                        alt="save" (click)="saveUnsaveJob(job);$event.stopPropagation()">  
                    </a> 
                    <a *ngIf="!showApplied">
                        <span (click)="applyJob(job);$event.stopPropagation()"
                        class="borderBtn applybtn"> Apply now </span> 
                    </a> 
                    <a *ngIf="showApplied">
                        <span (click)="withdrawJob(job);$event.stopPropagation()"
                        class="borderBtn applybtn"> Withdraw</span>
                    </a> 
              </div>
          </div>
      </a>
  </div>
</div>